// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type PlanPackageSummary_PlanPackageFragment = { __typename?: 'PlanPackage', id: string, displayName: string, designPackageCount: number, productOfferingCount: number, projectCount: number, assets: Array<{ __typename?: 'ReadyPlanAsset', id: string, active: boolean, isCoverPhoto: boolean, asset: { __typename?: 'Asset', id: string, previewUrl?: string | null | undefined } }>, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, minProgramData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, stories?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined }, maxProgramData: { __typename?: 'ProgramData', id: string, sellableSqft?: number | null | undefined, stories?: number | null | undefined, bedrooms?: number | null | undefined, fullBaths?: number | null | undefined, halfBaths?: number | null | undefined } };

export const PlanPackageSummary_PlanPackageFragmentDoc = gql`
    fragment PlanPackageSummary_PlanPackage on PlanPackage {
  id
  displayName
  designPackageCount
  productOfferingCount
  projectCount
  assets {
    id
    active
    isCoverPhoto
    asset {
      id
      previewUrl(resizing: {width: 326, region: FULL})
    }
  }
  aggregateLatest {
    id
  }
  minProgramData {
    id
    sellableSqft
    stories
    bedrooms
    fullBaths
    halfBaths
  }
  maxProgramData {
    id
    sellableSqft
    stories
    bedrooms
    fullBaths
    halfBaths
  }
}
    `;